// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"90dc4708","404":"03e2b53c"}[chunkId] + ".chunk.js";
};